import api from './api';

export interface ClientRecord {
  id: number;
  phone_number: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  origen: string;
  voice_model_selection?: string | null;
  customer_timezone?: string | null;
  hubspot_contact_id?: string | null;
  hubspot_sync_status: string;
  data_policy_accepted: boolean;
  last_seen_at?: string | null;
  created_at: string;
  updated_at: string;
  profile_attributes: Record<string, any>;
}

export interface ClientListResponse {
  total_count: number;
  skip: number;
  limit: number;
  clients: ClientRecord[];
}

export interface ClientImportRowResult {
  row_number: number;
  phone?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  origen?: string | null;
  voice_model_selection?: string | null;
  action?: string | null;
  is_valid: boolean;
  error?: string | null;
}

export interface ClientImportResponse {
  total_rows: number;
  created_rows: number;
  updated_rows: number;
  unchanged_rows: number;
  invalid_rows: number;
  rows: ClientImportRowResult[];
}

export interface ClientUpdatePayload {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  voice_model_selection?: string | null;
  customer_timezone?: string | null;
  hubspot_sync_status?: string | null;
  data_policy_accepted?: boolean | null;
}

class ClientService {
  async listClients(params: {
    skip?: number;
    limit?: number;
    search?: string;
    sync_status?: string;
  } = {}): Promise<ClientListResponse> {
    const response = await api.get<ClientListResponse>('/clients/', { params });
    return response.data;
  }

  async updateClient(clientId: number, payload: ClientUpdatePayload): Promise<ClientRecord> {
    const response = await api.patch<ClientRecord>(`/clients/${clientId}`, payload);
    return response.data;
  }

  async deleteClient(clientId: number): Promise<void> {
    await api.delete(`/clients/${clientId}`);
  }

  async downloadTemplate(): Promise<Blob> {
    const response = await api.get('/clients/template.xlsx', {
      responseType: 'blob',
    });
    return response.data as Blob;
  }

  async importClients(
    file: File,
    origen: string,
    policyPreaccepted: boolean
  ): Promise<ClientImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('origen', origen);
    formData.append('policy_preaccepted', policyPreaccepted ? 'true' : 'false');
    const response = await api.post<ClientImportResponse>('/clients/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
    return response.data;
  }
}

export const clientService = new ClientService();
export default clientService;
